// extracted by mini-css-extract-plugin
export var active = "Slider-module--active--4c84f";
export var arrows = "Slider-module--arrows--f5169";
export var card = "Slider-module--card--27aab";
export var content = "Slider-module--content--0be6a";
export var eyebrow = "Slider-module--eyebrow--f814b";
export var pagination = "Slider-module--pagination--d513e";
export var slide = "Slider-module--slide--b07d6";
export var slider = "Slider-module--slider--a049f";
export var slides = "Slider-module--slides--04805";
export var videoTitle = "Slider-module--video-title--732ae";